import { pick } from 'lodash'

const transformToSaveSop = sop => pick(sop, ['name', 'link'])

export default transformToSaveSop
